import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "piece-manager-container"
};
const _hoisted_2 = {
  class: "content-container"
};
const _hoisted_3 = {
  key: 0,
  class: "piece-grid-view"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "avatar-container"
};
const _hoisted_6 = {
  class: "nickname"
};
import { computed, ref } from 'vue';
import { ElImage, ElRow } from 'element-plus';
import SpriteGridView from "@/components/Stage/SpriteGridView.vue";
import 'element-plus/es/components/progress/style/css'; // constants

export default {
  __name: 'MapPieceManager',
  props: {
    actor: {
      type: Array,
      required: true
    }
  },
  emits: ['placePiece', 'close'],

  setup(__props, {
    emit: __emit
  }) {
    const pieceType = [{
      'key': 'cast',
      'name': '演员'
    }, {
      'key': 'role',
      'name': '角色'
    }, {
      'key': 'monster',
      'name': '怪物'
    }]; // pre-declaration

    const emits = __emit; // refs

    const selectedPieceType = ref(pieceType[0].name); // computed

    const selectedPieceTypeKey = computed(() => {
      let buffer = pieceType.filter(item => item.name === selectedPieceType.value);
      if (buffer.length === 0) return null;
      return buffer[0].key;
    }); // functions

    const clickPiece = item => {
      if (selectedPieceTypeKey.value === 'cast') {
        emits('placePiece', {
          x: 0,
          y: 0,
          width: 144,
          height: 144,
          imagePath: `${selectedPieceTypeKey.value}:${item.id}`
        });
      } else {
        emits('placePiece', item);
      }

      emits('close');
    };

    return (_ctx, _cache) => {
      const _component_el_segmented = _resolveComponent("el-segmented");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("text", {
          class: "form-title"
        }, "棋子创建", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_segmented, {
          modelValue: selectedPieceType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedPieceType.value = $event),
          options: pieceType.map(item => item.name),
          block: "",
          direction: "vertical"
        }, null, 8, ["modelValue", "options"]), _createElementVNode("div", _hoisted_2, [selectedPieceTypeKey.value === 'cast' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actor, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "grid-item",
            key: index,
            onClick: $event => clickPiece(item)
          }, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElImage), {
            src: item.avatar,
            fit: "cover",
            draggable: "false"
          }, null, 8, ["src"])]), _createElementVNode("text", _hoisted_6, _toDisplayString(item.nickname), 1)], 8, _hoisted_4);
        }), 128))])) : (_openBlock(), _createBlock(_unref(ElRow), {
          key: 1,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(SpriteGridView, {
            ref: "spriteView",
            "sprite-image-path": `${selectedPieceTypeKey.value}.png`,
            "json-path": `${selectedPieceTypeKey.value}.json`,
            "cell-size": 44,
            onSelect: clickPiece
          }, null, 8, ["sprite-image-path", "json-path"])]),
          _: 1
        }))])]),
        _: 1
      })]);
    };
  }

};